import { render } from "./PostViewReportSection.vue?vue&type=template&id=30c3520c&scoped=true"
import script from "./PostViewReportSection.vue?vue&type=script&lang=js"
export * from "./PostViewReportSection.vue?vue&type=script&lang=js"

import "@/assets/table.css?vue&type=style&index=0&id=30c3520c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c3520c"]])

export default __exports__